import React, {ChangeEvent, KeyboardEventHandler, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface MonthExpiryInputProps {
    monthExpiry: string;
    onSetMonthExpiry: (monthExpiry: string) => void;
    onSetMonthExpiryValid: (isMonthExpiryValid: boolean) => void;
}

export const MonthExpiryInput: React.FunctionComponent<MonthExpiryInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(false);
    const requiredMonthExpiryError = 'Month expiry is a required field.';
    const invalidMonthExpiryError = 'Month expiry field is invalid.';
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    useEffect(() => {
        props.onSetMonthExpiryValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        if (value.length === 1 && Number.isFinite(parseFloat(value)) && value !== '1' && value !== '0') {
            value = `0${value}`;
        }
        props.onSetMonthExpiry(value);
        validateMonthExpiry(undefined, value);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setIsSubmitted(true);
        validateMonthExpiry();
    }

    const validateMonthExpiry = (event: React.KeyboardEvent | undefined = undefined, month: string = '') => {
        month = month || props.monthExpiry;
        let errorsTemp: string[] = [];
        if (month === '') {
            errorsTemp.push(requiredMonthExpiryError);
        }
        const monthAsNumber = parseFloat(month);
        if (month.length < 2 || !Number.isFinite(monthAsNumber) || monthAsNumber <= 0 || monthAsNumber > 12) {
            errorsTemp.push(invalidMonthExpiryError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div>
        <Input isValid={isValid} type='number' maxLength={2} required={true} value={props.monthExpiry}
               onChange={onChange}
               onBlur={onBlur} onKeyUp={validateMonthExpiry}/>
        {isSubmitted && errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
